import * as firebase from "firebase";
/*
const config = {
    wawabded: {
        apiKey: "AIzaSyDD9Y4vcfh2MXUdYy-oFG8fscgOQLQmrHw",
        authDomain: "bham-wawan.firebaseapp.com",
        databaseURL: "https://bham-wawan.firebaseio.com",
        projectId: "bham-wawan",
        storageBucket: "bham-wawan.appspot.com",
        messagingSenderId: "686979390588"
    },
    production: { 
        apiKey: "AIzaSyAAVVZZ8nyF23cmMBSwt3cX65vic6fTIbQ",
        authDomain: "bham-production-c4c95.firebaseapp.com",
        databaseURL: "https://bham-production-c4c95.firebaseio.com",
        projectId: "bham-production-c4c95",
        storageBucket: "bham-production-c4c95.appspot.com",
        messagingSenderId: "327882655539"
    }
};*/

export const uiConfig = {
    signInFlow: "popup",
    signInSuccessUrl: "/my-account",
    signInOptions: [
        firebase.auth.GoogleAuthProvider.PROVIDER_ID,
        firebase.auth.FacebookAuthProvider.PROVIDER_ID,
        firebase.auth.PhoneAuthProvider.PROVIDER_ID,
    ]
};

// export const firebaseApp: firebase.app.App =  window['firebaseApp'] ? window['firebaseApp'] as any : ( firebase.apps && firebase.apps.length > 0  ?  firebase.apps[0] : null!)  ;  // firebase.initializeApp(config.production);
// 26 jan 2019 firestore di matikan di ganti dengan realtime database
// export const firestore = firebaseApp.firestore();
// const settings = {/* your settings... */ timestampsInSnapshots: true };
// firestore.settings(settings);
export interface ResponseData<DATA> {
    haveError: boolean;
    errorMessage?: string;
    errorCode?: string | number;
    data?: DATA;
}

export interface AuthUser {
    uid?: string;
    apiKey?: string;
    appName?: string;
    authDomain?: string;
    createdAt?: string | Date;
    displayName?: string;
    email?: string;
    emailVerified?: boolean;
    isAnonymous?: boolean;
    lastLoginAt?: string | Date;
    phoneNumber?: string;
    photoURL?: string;
    providerData?: ProviderData[];
    redirectEventId?: any;
    stsTokenManager?: StsTokenManager;
    disabled?: boolean;
}

export interface ProviderData {
    displayName?: string;
    email?: string;
    phoneNumber?: string;
    photoURL?: string;
    providerId?: string;
    uid?: string;
}

export interface StsTokenManager {
    accessToken?: string;
    apiKey?: string;
    expirationTime?: number | Date;
    refreshToken?: string;
}

const autoLogin = ( firebaseApp: firebase.app.App) => {
    firebaseApp.auth().signInAnonymously().catch((error: any) => {
        console.log(error);
    });
};

export function onAuthStateChanged( firebaseApp: firebase.app.App): Promise<ResponseData<AuthUser>> {
    return new Promise<ResponseData<AuthUser>>((accept: (n: any) => any, reject: (n: any) => any) => {
        firebaseApp.auth().onAuthStateChanged(
            (user: AuthUser | any) => {
                if (user) {
                    // const uid = user.uid;
                    const dateReturn: ResponseData<AuthUser> = {
                        haveError: false,
                        data: user
                    };
                    accept(dateReturn);
                } else {
                    autoLogin(firebaseApp);
                }
            }
        );
    });
}



// WEBPACK FOOTER //
// ./src/base/FirebaseInit.tsx